export default __webpack_public_path__ + "static/media/hair-hot-spring.e776ed78.png";